import { createRouter } from '@tanstack/react-router';

import { addRouterIntegration } from '@/features/logging/service/router';
import { DefaultErrorComponent } from '@/shared/components/defaultErrorComponent';
import { DefaultNotFoundComponent } from '@/shared/components/defaultNotFoundComponent';

import * as TanStackQueryProvider from './integrations/tanstack-query/root-provider';
import { routeTree } from './routeTree.gen';

export const TanStackQueryProviderContext = TanStackQueryProvider.getContext();

export const router = createRouter({
  routeTree,
  context: {
    ...TanStackQueryProviderContext,
  },
  defaultPreload: 'viewport',
  defaultPreloadStaleTime: 1000 * 60 * 5,
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultViewTransition: import.meta.env.VITE_PLATFORM !== 'MOBILE',
  defaultErrorComponent: DefaultErrorComponent,
  defaultNotFoundComponent: DefaultNotFoundComponent,
});

// Add TanStack Router integration for navigation tracing
addRouterIntegration(router);

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
